import "./Home.module.css";
import NavigationHub from "@/reusable_sections/Header";
import TheIgnitionPoint from "./sections/TheIgnitionPoint";
import LiveImpactTracker from "./sections/LiveImpactTracker";
import HighVelocityCampaigns from "./sections/HighVelocityCampaigns";
import GrowthSolutions from "./sections/GrowthSolutions";
import ClientEchoes from "./sections/ClientEchoes";
import SecureYourBlueprint from "./sections/SecureYourBlueprint";
import TheLabFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <NavigationHub />
      <TheIgnitionPoint />
      <LiveImpactTracker />
      <HighVelocityCampaigns />
      <GrowthSolutions />
      <ClientEchoes />
      <SecureYourBlueprint />
      <TheLabFooter />
    </div>;
}